module.exports = __webpack_public_path__ + "static/media/bar-chart.ad864dd9.svg";